module.exports = __webpack_public_path__ + "static/media/linkedin.0c1f89c2.svg";